import { useState, useRef, useEffect } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
const MultiSelectDropdown = ({ label,
  options = [],
  value = [],
  onChange,
  required,
  error,
  disabled = false,
  readOnly = false,
 }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
const dropdownRef = useRef(null);

useEffect(() => {
  if (open && dropdownRef.current) {
    dropdownRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }
}, [open]);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const toggleOption = (option) => {
    if (disabled || readOnly) return;
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };
  

  return (
    <div className="relative" ref={ref}>
      <label className="block text-sm font-medium mb-1">
        {label} {required && <span className="text-error">*</span>}
      </label>

    <button
  type="button"
  onClick={() => !disabled && setOpen(!open)}
  disabled={disabled}
  className={`
    w-full border rounded-md
    px-3 py-2 text-sm input-field
    flex justify-between items-center
   ${error ? "input-error" : ""}
   ${disabled ? "opacity-70 cursor-not-allowed bg-gray-50" : ""}`}
>
  <span className={value.length ? "text-black" : "text-gray-400"}>
    {value.length ? `${value.length} selected` : "- Select -"}
  </span>

  {open ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
</button>




     {open && (
  <div     ref={dropdownRef} className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-sm max-h-[30vh] min-h-[120px] overflow-y-auto
    menu-scrollbar">
    {options.map((option) => (
      <label
        key={option}
        className={`
          flex items-center gap-3
          px-4 py-2.5
          text-sm
          border-b border-gray-200
          last:border-b-0
          ${readOnly ? "cursor-default" : "cursor-pointer"}
        `}
      >
        <input
          type="checkbox"
          checked={value.includes(option)}
          onChange={() => toggleOption(option)}
          disabled={readOnly}
          className={`accent-primary w-4 h-4 ${readOnly ? "cursor-not-allowed" : ""}`}
        />
        <span className="text-gray-800">{option}</span>
      </label>
    ))}
  </div>
)}

<div className="min-h-[16px]">
    {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
</div>
    </div>
  );
};

export default MultiSelectDropdown;
